import { Button, ButtonProps } from 'antd'
import React from 'react'
import { styled } from 'styled-components'

const COMMON_TRANSITION = `0.8s cubic-bezier(0.5, 0.25, 0, 1)`

const Wrapper = styled(Button)<{ $isOpen: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  .burger {
    width: 16px;
    height: 14px;
    position: relative;
    transition: transform ${COMMON_TRANSITION};

    .burger__line {
      position: absolute;
      width: 16px;
      height: 2px;
      border-radius: 4px;
      background: #636363;
      transition:
        transform ${COMMON_TRANSITION},
        opacity ${COMMON_TRANSITION};

      &:nth-child(1) {
        top: 0;
      }

      &:nth-child(2) {
        top: 7px;
      }

      &:nth-child(3) {
        top: 14px;
      }
    }
  }

  ${({ $isOpen }) =>
    $isOpen &&
    `
      .burger {
        transform: translate(-3px, -1px);
        
        .burger__line {
          background:rgb(179, 179, 179);

          &:nth-child(1) {
            width: 10px;
            transform: rotate(-45deg) translate(-0px, 5.5px);
          }
          &:nth-child(2) {
            opacity: 0;
            width: 10px;
            transform: translate(15px, 0px);
          }
          &:nth-child(3) {
            width: 10px;
            transform: rotate(45deg) translate(-0px, -5.5px);
          }
        }
      }
    `}
`

type Props = ButtonProps & { isOpen: boolean }

export const BurgerButton: React.FC<Props> = ({ isOpen, ...props }) => {
  return (
    <>
      <Wrapper
        {...props}
        className="burger__button"
        type="text"
        size="small"
        $isOpen={isOpen}
      >
        <div className="burger">
          <div className="burger__line" />
          <div className="burger__line" />
          <div className="burger__line" />
        </div>
      </Wrapper>
    </>
  )
}
